import { InputAdornment } from '@mui/material';
import React from 'react';

export const DollarAdornment = () => (
    <InputAdornment className='custom-dollar-adornment' position='start' style={{ marginLeft: 10 }}>
        $
    </InputAdornment>
);
